import React from 'react';
import { ErrorMessage } from '@hookform/error-message';
import { useFormContext } from 'react-hook-form';
import { componentFromInput } from '../util';
var Errors = function Errors(_ref) {
  var name = _ref.name,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    _ref$wrapper = _ref.wrapper,
    Wrapper = _ref$wrapper === void 0 ? 'em' : _ref$wrapper,
    _ref$messages = _ref.messages,
    messages = _ref$messages === void 0 ? {} : _ref$messages;
  var _useFormContext = useFormContext(),
    _useFormContext$formS = _useFormContext.formState,
    isSubmitted = _useFormContext$formS.isSubmitted,
    errors = _useFormContext$formS.errors;

  // Lets prevent showing errors until we try to submit
  if (!isSubmitted) {
    return false;
  }
  return /*#__PURE__*/React.createElement(ErrorMessage, {
    errors: errors,
    name: name,
    render: function render(_ref2) {
      var messageKey = _ref2.message;
      var ErrorText = componentFromInput(messages[messageKey] || '');
      return /*#__PURE__*/React.createElement(Wrapper, {
        className: styles.error || 'error'
      }, /*#__PURE__*/React.createElement(ErrorText, null));
    }
  });
};
export default Errors;